// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__0RuPC","default":"Badge_default__qvlMu","secondary":"Badge_secondary__GhJGU","destructive":"Badge_destructive__D03qe","outline":"Badge_outline__tvIFF"};